import { render, staticRenderFns } from "./BookCall.vue?vue&type=template&id=19ba979a"
import script from "./BookCall.vue?vue&type=script&lang=js"
export * from "./BookCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports